import getGeo from '../glb/geo';

export default function () {
    return {
        geo: getGeo(),
        ctx: null,
        ctxString: '',
    };
}
